import { t, type MessageKey } from "../i18n";
import { ArrowRightIcon } from "./icons";

// Direct screens of claude.ai. Plugins: exactly Customize → Plugins (owner 2026-10-04, ADR-0032) -
// installed plugins are one tab away there, and before the install «Yours» would be empty.
export const CLAUDE_CONNECTORS_URL = "https://claude.ai/customize/connectors";
export const CLAUDE_PLUGINS_URL = "https://claude.ai/customize/plugins";

/** Buttons to the exact claude.ai screens and one line saying what to press there (ADR-0028 look).
 *  `quiet` - secondary buttons for a fallback spot (the /install «Then» box), `hint` - that spot's line. */
export function ClaudeLinks({
  plugin = true,
  quiet = false,
  hint = "claudeLinks.hint",
}: {
  plugin?: boolean;
  quiet?: boolean;
  hint?: MessageKey;
}) {
  return (
    <div className={quiet ? "claude-links quiet" : "claude-links"} data-testid="claude-links">
      {quiet && <p className="hint">{t(hint)}</p>}
      <div className="claude-links-row">
        {plugin && (
          <a className={quiet ? "btn" : "btn btn-primary"} href={CLAUDE_PLUGINS_URL} target="_blank" rel="noreferrer">
            {t("claudeLinks.plugins")}
            <ArrowRightIcon size={16} />
          </a>
        )}
        <a className={quiet || plugin ? "btn" : "btn btn-primary"} href={CLAUDE_CONNECTORS_URL} target="_blank" rel="noreferrer">
          {t("claudeLinks.connectors")}
          <ArrowRightIcon size={16} />
        </a>
      </div>
      {!quiet && <p className="hint">{t(hint)}</p>}
    </div>
  );
}
